import { render, staticRenderFns } from "./HotTopicNew.vue?vue&type=template&id=7f460262&scoped=true"
import script from "./HotTopicNew.vue?vue&type=script&lang=js"
export * from "./HotTopicNew.vue?vue&type=script&lang=js"
import style0 from "./HotTopicNew.vue?vue&type=style&index=0&id=7f460262&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f460262",
  null
  
)

export default component.exports